import React from "react";

const Brand = () => {
  return (
    <div className="brand">
      <h1>KestMe</h1>
      <p>
        A new way to text{" "}
        <span role="img" aria-label="crazyemote">
          😜
        </span>
      </p>
    </div>
  );
};

export default Brand;
